import { useState } from "react";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Home } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function LoginPage() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false && user !== null) return <Navigate to="/admin" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Benvenuto Davide.");
      nav("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Credenziali non valide");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6" data-testid="login-page">
      <motion.form
        onSubmit={onSubmit}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="w-full max-w-md border border-white/10 p-10 bg-[#080808]"
      >
        <div className="flex items-center justify-between mb-6">
          <div className="label-eyebrow text-neutral-500">Area riservata</div>
          <Link
            to="/"
            className="inline-flex items-center gap-2 label-eyebrow text-neutral-400 hover:text-white border border-white/10 hover:border-white/40 px-3 py-1.5 transition-colors"
            data-testid="login-home-link"
          >
            <Home size={12} /> Torna al sito
          </Link>
        </div>
        <h1 className="font-serif text-4xl text-white mb-10">Accedi</h1>

        <label className="label-eyebrow text-neutral-500 block mb-2">Email</label>
        <input
          type="email" required autoFocus
          value={email} onChange={(e) => setEmail(e.target.value)}
          className="w-full bg-transparent border border-white/10 px-4 py-3 text-white focus:outline-none focus:border-white/40 mb-6"
          data-testid="login-email-input"
        />

        <label className="label-eyebrow text-neutral-500 block mb-2">Password</label>
        <input
          type="password" required
          value={password} onChange={(e) => setPassword(e.target.value)}
          className="w-full bg-transparent border border-white/10 px-4 py-3 text-white focus:outline-none focus:border-white/40 mb-10"
          data-testid="login-password-input"
        />

        <button
          type="submit" disabled={busy}
          className="btn-magnetic btn-solid w-full justify-center disabled:opacity-50"
          data-testid="login-submit-btn"
        >
          {busy ? "Attendere…" : "Entra"}
        </button>
      </motion.form>
    </div>
  );
}
